const worksite = {
  "page": {
    "loading": "페이지를 불러오는 중입니다...",
  },
  "panel": {
    "membersTitle": "접속자",
    "membersEmpty": "접속 중인 작업자가 없습니다",
    "membersCount": "전체 {{count}}명",
    "refreshMembers": "접속자 위치 새로고침",
    "unknownPosition": "위치 미상",
    "pollingDegraded": "연결이 지연되고 있습니다 — 마지막 스냅샷 표시 중",
  },
  "role": {
    "owner": "소유자",
    "inspector": "점검자",
    "viewer": "뷰어",
  },
  "relative": {
    "justNow": "방금 전",
    "minutesAgo": "{{value}}분 전",
    "hoursAgo": "{{value}}시간 전",
    "daysAgo": "{{value}}일 전",
    "unknown": "-",
  },
  "member": {
    "role": "역할",
    "lastReported": "최종 위치 보고",
    "accuracy": "GPS 정확도",
    "violationState": "위반 상태",
    "violationNone": "정상",
    "closeCard": "상세 카드 닫기",
  },
  "violation": {
    "badge": "위반",
    "toast": "{{name}} — {{zone}} 금지구역 위반",
    "unknownZone": "금지구역",
  },
  "marker": {
    "ariaLabel": "작업자 {{label}} 마커",
    "violationSpoken": "금지구역 위반 중",
  },
  "layers3d": {
    "title": "레이어",
    "mesh": "현황 메쉬",
    "loading": "3D 레이어를 불러오는 중...",
    "empty": "표시할 3D 레이어(메쉬·BIM·GIS)가 없습니다",
    "emptyModels": "표시할 3D 레이어(메쉬·BIM)가 없습니다",
    "loadFailed": "불러오지 못했습니다",
    "count": "전체 {{count}}개",
  },
  "zones": {
    "manage": "금지구역 관리",
    "count": "전체 {{count}}개",
    "empty": "등록된 금지구역이 없습니다",
    "draw": "새 금지구역 그리기",
    "drawingHint":
      "지도를 클릭해 꼭짓점을 찍고, 더블클릭으로 완료하세요. ESC 또는 우클릭으로 취소할 수 있습니다.",
    "drawCancel": "그리기 취소",
    "rename": "이름 변경",
    "renameInput": "{{name}} 이름",
    "renameConfirm": "{{name}} 이름 저장",
    "renameCancel": "{{name}} 이름 바꾸기 취소",
    "delete": "삭제",
    "rowMenu": "{{name}} 메뉴",
    "active": "활성",
    "deleteConfirmTitle": "금지구역 삭제",
    "deleteConfirmMessage": "'{{name}}' 구역을 삭제할까요?",
    "deleteConfirmSub": "되돌릴 수 없습니다.",
    "cancel": "취소",
  },
  "zoneDialog": {
    "createTitle": "새 금지구역 이름",
    "renameTitle": "금지구역 이름 변경",
    "nameLabel": "구역 이름",
    "confirm": "확인",
    "cancel": "취소",
    "tooFewPoints": "꼭짓점을 3개 이상 찍어야 합니다",
  },
  "error": {
    "presencePoll": "접속자 정보를 불러오지 못했습니다 — 자동으로 재시도합니다",
    "presenceLoad": "접속자 목록을 불러오지 못했습니다",
    "projectNoLocation": "이 현장에는 지도에 표시할 위치 정보가 없습니다",
    "projectLoad": "현장 정보를 불러오지 못했습니다",
    "zonesLoad": "금지구역 목록을 불러오지 못했습니다",
    "zoneCreate": "금지구역 생성에 실패했습니다",
    "zoneUpdate": "금지구역 수정에 실패했습니다",
    "zoneDelete": "금지구역 삭제에 실패했습니다",
    "noPermission": "권한이 없습니다",
  },
} as const;

export default worksite;
